class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.modal = this.closest('.search-modal');
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.suggestions=this.querySelector('[data-popular-search]');
    this.searchTerm = '';
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.querySelector('form.search').addEventListener('submit', this.onFormSubmit.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));
    this.querySelector('button[type="reset"]').addEventListener('click', this.clear.bind(this));
    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
      
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
   this.addEventListener('focusout', this.onFocusOut.bind(this));
//this.addEventListener('keyup', this.onKeyup.bind(this));
  //  this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-content")?.remove();
    }
    if(newSearchTerm != ''){
      this.querySelector('button[type="reset"]').classList.remove('hidden')
    }else{
      this.querySelector('button[type="reset"]').classList.add('hidden');
    }
    this.searchTerm = newSearchTerm;
    if (!this.searchTerm.length) {
      this.clear();
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
    focusElement = this
    trapFocusElements(this);
     setTimeout(() => {
          const searchInput = this.querySelector("#Search-In-Template");
          if (searchInput) {
            searchInput.setAttribute('tabindex', '0');
            searchInput.focus();
          }
      }, 100);
  }
  
  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    document.body.classList.add('predictive-search--focus');
    const currentSearchTerm = this.getQuery();
    if (!currentSearchTerm.length) return;
    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  } 

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) {
      this.clear(event);
      this.close(true);
    }
    event.preventDefault();
    switch (event.code) {
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }
 
  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');
    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    
    if (this.cachedResults[queryKey]) {
        if(this.suggestions){
          this.suggestions.classList.add("hidden")
        }
      this.renderSearchResults(this.cachedResults[queryKey]);
      if (this.modal) this.modal.classList.add('searching');
      return;
    }
    
    // First try regular predictive search
    fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)
      .then((response) => { 
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        
        // Check if we got results from predictive search
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = resultsMarkup;
        const hasResults = tempDiv.querySelector('.grid-row')?.children.length > 0;
        
        if (!hasResults) {
          // No results from predictive search, try main search API for SKU
          return this.searchMainAPI(searchTerm, queryKey);
        }
        
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          }
        );
        if(this.suggestions){
          this.suggestions.classList.add("hidden")
        }
        this.renderSearchResults(resultsMarkup);
         if (typeof animationCheck !== 'undefined' && animationCheck) {
          if (typeof AOS !== 'undefined') {
               AOS.refreshHard()
            }
          }
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      }); 
  }
  
  searchMainAPI(searchTerm, queryKey) {
    // Use main search API which supports sku: filter
    fetch(`${window.routes.search_url}?q=${encodeURIComponent(searchTerm)}&type=product`)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        
        // Try to find the product grid in multiple ways
        let productGrid = doc.querySelector('#result-product-grid .grid-row');
        
        if (!productGrid) {
          productGrid = doc.querySelector('.collection-result .grid-row');
        }
        
        if (!productGrid) {
          productGrid = doc.querySelector('.search-products-wrapper .grid-row');
        }
        
        if (!productGrid) {
          productGrid = doc.querySelector('.grid-row');
        }
        
        if (productGrid) {
          // Filter out empty wrappers and get actual product items
          const productItems = Array.from(productGrid.children).filter(child => 
            !child.classList.contains('empty-wrapper') && 
            (child.classList.contains('grid-item-md-3') || 
             child.querySelector('[class*="grid-item"]'))
          );
          
          if (productItems.length > 0) {
            // Build predictive search format results
            const resultsMarkup = this.buildPredictiveResults(productItems, searchTerm);
            
            this.allPredictiveSearchInstances.forEach(
              (predictiveSearchInstance) => {
                predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
              }
            );
            if(this.suggestions){
              this.suggestions.classList.add("hidden")
            }
            this.renderSearchResults(resultsMarkup);
            if (typeof animationCheck !== 'undefined' && animationCheck) {
              if (typeof AOS !== 'undefined') {
                AOS.refreshHard()
              }
            }
            return;
          }
        }
        
        // No results found, show empty state
        const noResultsMarkup = `
          <div id="predictive-search-results-content" class="search-result not-found align-center">
            <span>
              <svg width="79" height="84" viewBox="0 0 79 84" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.001 2.362L15.995 2.366C15.881 2.442 15.775 2.528 15.677 2.624L2.159 15.951C0.837 17.097 0 18.789 0 20.676V76.903C0 80.355 2.798 83.153 6.25 83.153H41.675C42.825 83.153 43.758 82.219 43.758 81.07C43.758 79.92 42.825 78.986 41.675 78.986H6.25C5.1 78.986 4.167 78.053 4.167 76.903V20.676C4.167 20.083 4.415 19.548 4.812 19.169C4.863 19.129 4.913 19.086 4.961 19.04C5.315 18.76 5.763 18.593 6.25 18.593H12.431C15.831 18.593 18.607 15.875 18.679 12.475C18.721 10.513 18.771 8.168 18.812 6.206C18.836 5.072 19.762 4.166 20.895 4.166H57.622C58.772 4.166 59.705 5.099 59.705 6.25C59.705 14.725 59.705 33.176 59.705 33.176C59.705 34.326 60.639 35.26 61.788 35.26C62.938 35.26 63.872 34.326 63.872 33.176V6.25C63.872 2.798 61.073 0 57.622 0C49.025 0 29.416 0 20.895 0C18.915 0 17.147 0.921 16.001 2.362ZM65.732 68.702L75.065 78.036C75.878 78.849 77.199 78.849 78.012 78.036C78.825 77.223 78.825 75.903 78.012 75.09L68.733 65.811C70.949 63.044 72.276 59.535 72.276 55.718C72.276 46.8 65.035 39.559 56.117 39.559C47.199 39.559 39.958 46.8 39.958 55.718C39.958 64.636 47.199 71.876 56.117 71.876C59.717 71.876 63.044 70.696 65.732 68.702ZM56.117 43.726C62.736 43.726 68.109 49.099 68.109 55.718C68.109 62.336 62.736 67.71 56.117 67.71C49.498 67.71 44.125 62.336 44.125 55.718C44.125 49.099 49.498 43.726 56.117 43.726ZM53.171 55.718L49.436 59.452C48.623 60.265 48.623 61.585 49.436 62.398C50.249 63.211 51.57 63.211 52.383 62.398L56.117 58.664L59.851 62.398C60.664 63.212 61.984 63.212 62.798 62.399C63.611 61.585 63.611 60.265 62.798 59.452L59.063 55.718L62.798 51.983C63.611 51.17 63.611 49.85 62.798 49.037C61.985 48.224 60.664 48.224 59.851 49.037L56.117 52.771L52.383 49.037C51.57 48.224 50.25 48.224 49.436 49.037C48.623 49.85 48.623 51.17 49.436 51.983L53.171 55.718ZM17.655 56.173H32.296C33.446 56.173 34.38 55.239 34.38 54.09C34.38 52.94 33.446 52.006 32.296 52.006H17.655C16.506 52.006 15.572 52.94 15.572 54.09C15.572 55.239 16.506 56.173 17.655 56.173ZM17.655 43.668H32.296C33.446 43.668 34.38 42.735 34.38 41.585C34.38 40.435 33.446 39.502 32.296 39.502H17.655C16.506 39.502 15.572 40.435 15.572 41.585C15.572 42.735 16.506 43.668 17.655 43.668ZM17.655 31.146H46.938C48.087 31.146 49.021 30.213 49.021 29.063C49.021 27.913 48.087 26.98 46.938 26.98H17.655C16.506 26.98 15.572 27.913 15.572 29.063C15.572 30.213 16.506 31.146 17.655 31.146ZM14.573 9.563L9.64 14.426H12.431C13.564 14.426 14.49 13.52 14.514 12.387L14.573 9.563Z" fill="#B3B3B3"/>
              </svg>
            </span>
            <h3>No results found for "${searchTerm}"</h3>
            <p>Try searching by product name or description</p>
          </div>
        `;
        
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = noResultsMarkup;
          }
        );
        if(this.suggestions){
          this.suggestions.classList.add("hidden")
        }
        this.renderSearchResults(noResultsMarkup);
      })
      .catch(() => {
        // Search API failed, just show no results
        const noResultsMarkup = `
          <div id="predictive-search-results-content" class="search-result not-found align-center">
            <span>
              <svg width="79" height="84" viewBox="0 0 79 84" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.001 2.362L15.995 2.366C15.881 2.442 15.775 2.528 15.677 2.624L2.159 15.951C0.837 17.097 0 18.789 0 20.676V76.903C0 80.355 2.798 83.153 6.25 83.153H41.675C42.825 83.153 43.758 82.219 43.758 81.07C43.758 79.92 42.825 78.986 41.675 78.986H6.25C5.1 78.986 4.167 78.053 4.167 76.903V20.676C4.167 20.083 4.415 19.548 4.812 19.169C4.863 19.129 4.913 19.086 4.961 19.04C5.315 18.76 5.763 18.593 6.25 18.593H12.431C15.831 18.593 18.607 15.875 18.679 12.475C18.721 10.513 18.771 8.168 18.812 6.206C18.836 5.072 19.762 4.166 20.895 4.166H57.622C58.772 4.166 59.705 5.099 59.705 6.25C59.705 14.725 59.705 33.176 59.705 33.176C59.705 34.326 60.639 35.26 61.788 35.26C62.938 35.26 63.872 34.326 63.872 33.176V6.25C63.872 2.798 61.073 0 57.622 0C49.025 0 29.416 0 20.895 0C18.915 0 17.147 0.921 16.001 2.362ZM65.732 68.702L75.065 78.036C75.878 78.849 77.199 78.849 78.012 78.036C78.825 77.223 78.825 75.903 78.012 75.09L68.733 65.811C70.949 63.044 72.276 59.535 72.276 55.718C72.276 46.8 65.035 39.559 56.117 39.559C47.199 39.559 39.958 46.8 39.958 55.718C39.958 64.636 47.199 71.876 56.117 71.876C59.717 71.876 63.044 70.696 65.732 68.702ZM56.117 43.726C62.736 43.726 68.109 49.099 68.109 55.718C68.109 62.336 62.736 67.71 56.117 67.71C49.498 67.71 44.125 62.336 44.125 55.718C44.125 49.099 49.498 43.726 56.117 43.726ZM53.171 55.718L49.436 59.452C48.623 60.265 48.623 61.585 49.436 62.398C50.249 63.211 51.57 63.211 52.383 62.398L56.117 58.664L59.851 62.398C60.664 63.212 61.984 63.212 62.798 62.399C63.611 61.585 63.611 60.265 62.798 59.452L59.063 55.718L62.798 51.983C63.611 51.17 63.611 49.85 62.798 49.037C61.985 48.224 60.664 48.224 59.851 49.037L56.117 52.771L52.383 49.037C51.57 48.224 50.25 48.224 49.436 49.037C48.623 49.85 48.623 51.17 49.436 51.983L53.171 55.718ZM17.655 56.173H32.296C33.446 56.173 34.38 55.239 34.38 54.09C34.38 52.94 33.446 52.006 32.296 52.006H17.655C16.506 52.006 15.572 52.94 15.572 54.09C15.572 55.239 16.506 56.173 17.655 56.173ZM17.655 43.668H32.296C33.446 43.668 34.38 42.735 34.38 41.585C34.38 40.435 33.446 39.502 32.296 39.502H17.655C16.506 39.502 15.572 40.435 15.572 41.585C15.572 42.735 16.506 43.668 17.655 43.668ZM17.655 31.146H46.938C48.087 31.146 49.021 30.213 49.021 29.063C49.021 27.913 48.087 26.98 46.938 26.98H17.655C16.506 26.98 15.572 27.913 15.572 29.063C15.572 30.213 16.506 31.146 17.655 31.146ZM14.573 9.563L9.64 14.426H12.431C13.564 14.426 14.49 13.52 14.514 12.387L14.573 9.563Z" fill="#B3B3B3"/>
            </svg>
          </span>
          <h3>No results found for "${searchTerm}"</h3>
          <p>Try searching by product name or description</p>
        </div>
      `;
      
      this.allPredictiveSearchInstances.forEach(
        (predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = noResultsMarkup;
        }
      );
      if(this.suggestions){
        this.suggestions.classList.add("hidden")
      }
      this.renderSearchResults(noResultsMarkup);
      });
  }
  
  buildPredictiveResults(productItems, searchTerm) {
    // Convert main search results to predictive search format
    const products = productItems.slice(0, 6); // Limit to 6 products
    
    const productHTML = products.map(product => product.outerHTML).join('');
    
    return `
      <div id="predictive-search-results-content" class="search-content">
        <div class="column-right">
          <div class="treanding-products-list">
            <div class="heading-header flex">
              <span class="textMedium font-heading">Products</span>
            </div>
            <div class="grid-row">
              ${productHTML}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('[data-predictive-search]');
    this.setLiveRegionText(storeLoader);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statuscontent) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    if(this.suggestions){
      this.suggestions.classList.add("populat-content-blur")
    }
    this.statusElement.innerHTML = statuscontent;
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);  
    this.setLiveRegionResults();
  }

  setLiveRegionResults() { 
    this.removeAttribute('loading');
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
    }
    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute('aria-selected', false);
    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.input.setAttribute('aria-expanded', false);
    document.body.classList.remove('predictive-search--focus');
  }

  clear(event) {
    this.input.value = '';
    this.querySelector('[data-predictive-search]').innerHTML=''
    this.input.focus();
    if(this.suggestions){
        this.suggestions.classList.remove("hidden","populat-content-blur")
    }
    if (this.modal) this.modal.classList.remove('searching');
  }
}

customElements.define('predictive-search', PredictiveSearch);